import { createWritableGenericContext } from '@luna/context';

type Context = {
    visible: boolean;
    navigationStrategy?: string;
};

const { createContextProvider, useContext } =
    createWritableGenericContext<Context>('NavigationContext');

export const createNavigationContext = createContextProvider;
export const useNavigationContext = useContext;
